export default {
  title: "You have only <b>a read access</b>.",
  description:
    "In order to edit info, please contact your collective organiser."
};
